module.exports = __webpack_public_path__ + "img/Landingpage.2b950e1f.png";